import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/*
  Custom Route Reuse Strategy to preserve the state of specific routes when switching between tabs.
*/
@Injectable({
  providedIn: 'root'
})
export class CustomRouteReuseStrategyService implements RouteReuseStrategy {
  private storedRouteHandles: Map<string, DetachedRouteHandle> = new Map();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Determine which routes should be detached and their state preserved
    return route.routeConfig?.path === 'configuration' || route.routeConfig?.path === 'results';
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    // Store the route handle for later reuse
    this.storedRouteHandles.set(this.getRouteUrl(route), handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    // Determine if a previously detached route can be reattached
    return this.storedRouteHandles.has(this.getRouteUrl(route));
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    // Retrieve the previously detached route handle
    return this.storedRouteHandles.get(this.getRouteUrl(route))!;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    // Determine if the future route should reuse the current route
    return future.routeConfig === current.routeConfig;
  }

  private getRouteUrl(route: ActivatedRouteSnapshot): string {
    // Generate a unique URL for the route
    return `${route.routeConfig?.path ?? route.component?.name}`;
  }
}
